import { ImportError } from './ImportError'

/**
 * Error that is thrown when a import value exceeds maximum length.
 */
export class ImportLengthError extends ImportError {
  constructor(message: string) {
    super(message)
    this.name = 'ImportLengthError'
    Object.setPrototypeOf(this, new.target.prototype)
  }
}
